/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React, { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'
import { Table, Button } from 'reactstrap'
import Pagination from 'react-js-pagination'
import defaultCover from 'Shared/img/defaultCover.png'
import PlaylistDetailsModal from 'Containers/AdminPanel/components/PlaylistDetailsModal'

const PlaylistCard = ({
  allFoundPlaylists,
  getPlaylists,
  isSearch,
  setFoundPlaylists,
  totalPlaylist,
  playlists,
  tabName,
  modalToggle,
  setPlaylist,
  getPlaylistInfo,
  setIsModalLoading,
  setPlaylistStatus,
  setIsSubmitSuccessful,
  setIsError,
  setDetailsShow,
  isError,
  isLoading,
  isSubmitSuccessful,
  item,
  modal,
  itemstatus,
  activatePlaylist,
  deactivatePlaylist,
  handleRefreshDiscoveredOn,
  detailShow,
}) => {
  const [activePage, setActivePage] = useState(1)

  useEffect(() => {
    setActivePage(1)
  }, [tabName])

  const handlePageChange = pageNumber => {
    const offset = (pageNumber - 1) * 5
    setActivePage(pageNumber)

    if (isSearch) {
      setFoundPlaylists(allFoundPlaylists.slice(offset, offset + 5))
    } else {
      getPlaylists(tabName, pageNumber)
    }
  }

  //  eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderStatus = (status, isNew) => {
    if (status === 'on_review' && isNew) {
      return (
        <>
          <span style={{ color: '#58B660' }}>New!</span> <br />
          <span style={{ color: '#F19236' }}>Review needed</span>
        </>
      )
    }
    if (status === 'activated' && !isNew) {
      return <span style={{ color: '#58B660' }}>Activated</span>
    }
    if (status === 'deactivated') {
      return <span style={{ color: '#EC5765' }}>Deactivated</span>
    }
    if (status === 'on_review' || status === 'activated') {
      return <span style={{ color: '#F19236' }}>Review needed</span>
    }
    return null
  }

  const returnStatus = status => {
    if (status === 'activated') {
      return 'Activated'
    }
    if (status === 'deactivated') {
      return 'Dectivated'
    }
    if (status === 'pending') {
      return 'Review needed'
    }
    return ''
  }

  const handleOpenModal = playlist_id => {
    setIsSubmitSuccessful(false)
    setIsError(false)
    modalToggle()
    setIsModalLoading(true)
    getPlaylistInfo(playlist_id, (err, res) => {
      if (!err) {
        setIsModalLoading(false)
        setPlaylist(res)
        setPlaylistStatus(returnStatus(res.playlist.status))
      }
    })
    setDetailsShow(false)
  }

  const calculateListeners = (stats, followers) => {
    if (stats.length === 0) return 'no data'

    const statsList = stats.filter(
      ({ Campaign: { status } }) => status === 'ended'
    )

    if (isEmpty(statsList)) return 0
    const averageListeners =
      statsList.reduce((a, b) => a + b.listeners, 0) / statsList.length
    const percents = (averageListeners / followers) * 100
    return `${averageListeners.toFixed()} (${percents.toFixed(2)}%)`
  }

  const calculateStreams = stats => {
    if (stats.length === 0) return 'no data'

    const statsList = stats.filter(
      ({ Campaign: { status } }) => status === 'ended'
    )
    if (isEmpty(statsList)) return 0
    const averageListeners =
      statsList.reduce((a, b) => a + b.listeners, 0) / statsList.length
    const averageStreams =
      statsList.reduce((a, b) => a + b.streams, 0) / statsList.length
    const percents = averageStreams / averageListeners
    return `${averageStreams.toFixed()} (${percents.toFixed(2)})`
  }

  return (
    <>
      {!isEmpty(playlists) ? (
        <Table responsive striped>
          <tbody>
            {playlists.map(
              ({
                id,
                playlist_name,
                playlist_cover,
                playlist_url,
                followers,
                status,
                is_new,
                Curator: {
                  User: { email },
                },
                ArtistStats,
                reviews_amount,
              }) => (
                <>
                  <tr key={id} className="playlists-td">
                    <PlaylistDetailsModal
                      fade={false}
                      errorMessage="Something went wrong."
                      isError={isError}
                      isLoading={isLoading}
                      isSubmitSuccessful={isSubmitSuccessful}
                      item={item}
                      modal={modal}
                      toggle={modalToggle}
                      status={itemstatus}
                      activatePlaylist={activatePlaylist}
                      deactivatePlaylist={deactivatePlaylist}
                      handleRefreshDiscoveredOn={handleRefreshDiscoveredOn}
                      detailShow={detailShow}
                      setDetailsShow={setDetailsShow}
                    />
                    <td style={{ width: '50px' }}>
                      <img
                        alt="playlist-cover"
                        className="playlist-cover"
                        src={playlist_cover || defaultCover}
                        style={{
                          height: '50px',
                          width: '50px',
                          borderRadius: '4px',
                        }}
                      />
                    </td>
                    <td style={{ width: '240px', padding: '24px 16px' }}>
                      <a
                        href={`https://open.spotify.com/playlist/${playlist_url.slice(
                          -22
                        )}`}
                        // eslint-disable-next-line react/jsx-no-target-blank
                        target="_blank"
                        style={{ color: '#646877' }}
                      >
                        {playlist_name}
                      </a>
                      <br />
                      <span style={{ fontSize: '10px' }}>by {email}</span>
                    </td>
                    <td style={{ width: '240px', padding: '24px 16px' }}>
                      <span>Followers:</span> {followers} <br />
                      <span>Listeners:</span>&nbsp;
                      {calculateListeners(ArtistStats, followers)} <br />
                      <span>Streams:</span> {calculateStreams(ArtistStats)}
                    </td>
                    <td style={{ width: '150px' }}>
                      {renderStatus(status, is_new)}
                    </td>
                    <td style={{ width: '150px' }}>
                      <span style={{ fontWeight: '600' }}>
                        {reviews_amount}
                      </span>
                      &nbsp;
                      <br />
                      <span>awaiting reviews</span>
                    </td>
                    <td style={{ display: 'flex' }}>
                      <Button
                        className="btn-outline-success"
                        style={{
                          padding: '9px 23px',
                          height: '40px',
                          margin: 'auto',
                        }}
                        onClick={() => handleOpenModal(id, is_new, status)}
                      >
                        Details
                      </Button>
                    </td>
                  </tr>
                </>
              )
            )}
          </tbody>
        </Table>
      ) : (
        <p className="campaign-not-found">Playlists not found</p>
      )}
      <div className="pagination-bottom">
        {
          <Pagination
            activePage={activePage}
            itemsCountPerPage={5}
            pageRangeDisplayed={5}
            totalItemsCount={totalPlaylist}
            onChange={handlePageChange}
          />
        }
      </div>
    </>
  )
}

export default PlaylistCard
